import React, { Fragment, RefObject } from "react";
import EntitledSection from "./EntitledSection";
import entitlements from "../config/entitlements";
import { Row, Table, Col } from "antd";
import {
  InteractionMode,
  PreOpportunityInteraction,
} from "../helpers/shared-interfaces";
import { FormInstance } from "antd/lib/form";

interface Props {
  interactions?: PreOpportunityInteraction[];
  reference: RefObject<FormInstance>;
  showForm: boolean;
  showBorder?: boolean;
  showHeading?: boolean;
}

interface State {
  interactionModes: InteractionMode[];
}

export const columns = [
  {
    title: "Activity Date",
    dataIndex: "activityDate",
    key: "activityDate",
    render(text: string, record: PreOpportunityInteraction): JSX.Element {
      return <span>{record.activityDate}</span>;
    },
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    render(text: string, record: PreOpportunityInteraction): JSX.Element {
      return <span>{record.email?.address}</span>;
    },
  },
  {
    title: "Phone",
    dataIndex: "phone",
    key: "phone",
    render(text: string, record: PreOpportunityInteraction): JSX.Element {
      return <span>{record.phone.number}</span>;
    },
  },
  {
    title: "First Name",
    dataIndex: "firstName",
    key: "firstName",
    render(text: string): JSX.Element {
      return <span>{text}</span>;
    },
  },
  {
    title: "Last Name",
    dataIndex: "lastName",
    key: "lastName",
    render(text: string): JSX.Element {
      return <span>{text}</span>;
    },
  },
  {
    title: "Source",
    dataIndex: "interactionSource",
    key: "interactionSource",
    render(text: string, record: PreOpportunityInteraction): JSX.Element {
      return <span>{record.interactionSource.name}</span>;
    },
  },
  {
    title: "Prospect",
    dataIndex: "prospect",
    key: "prospect",
    render(text: string, record: PreOpportunityInteraction): JSX.Element {
      return <span>{record.opportunityProspect.name}</span>;
    },
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    render(text: string, record: PreOpportunityInteraction): JSX.Element {
      return <span>{record.description}</span>;
    },
  },
];

export function InteractionTableFactory(
  data?: PreOpportunityInteraction[],
): JSX.Element {
  const tempData: PreOpportunityInteraction[] = data
    ? data.map(
        (interaction: PreOpportunityInteraction): PreOpportunityInteraction => {
          return { ...interaction };
        },
      )
    : [];

  return (
    <Table
      bordered={true}
      columns={columns}
      dataSource={tempData}
      pagination={false}
    />
  );
}

export default class PreOpportunityInteractionsSection extends React.Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);
    this.state = { interactionModes: [] };
  }

  render(): JSX.Element {
    return (
      <Fragment>
        <div
          style={
            this.props.showBorder
              ? {
                  border: "1px solid rgb(232 232 232)",
                  padding: "20px",
                  boxSizing: "border-box",
                }
              : undefined
          }
        >
          
          {!this.props.showForm && (
            <Row>
              <Col span={24}>
                <EntitledSection
                  entitlement={
                    entitlements.BusinessDevelopment.interactions.list
                  }
                >
                  {InteractionTableFactory(this.props.interactions)}
                </EntitledSection>
              </Col>
            </Row>
          )}
        </div>
      </Fragment>
    );
  }
}
